export const mapCssValue = (value, units = 'px') => typeof value === 'number' ? `${value}${units}` : value;
